import { Pipe, PipeTransform } from '@angular/core';
import { EmailEntity } from '../email-chip-input-form.component';
@Pipe({
    name: 'emailChipDisplay',
    standalone: false
})
export class EmailChipDisplayPipe implements PipeTransform {
    transform(entity: EmailEntity): string {
        const names = [entity.firstName, entity.lastName];
        const displayable = names
            .filter((x) => x)
            .map((x) => x.trim())
            .filter((x) => x.length > 0);
        return displayable.length === names.length
            ? displayable.join(' ').toString()
            : entity.email;
    }
}
